module.exports = __webpack_public_path__ + "img/p14.b23a339b.png";